// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.46.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".faux-modal{min-height:100vh;overflow:auto}.faux-modal .i-stacked-logo{width:128px}", ""]);
// Exports
module.exports = exports;
